import {MUTATION_NAME} from '@/static/global-variables';

const aocStore = {
    namespaced: true,
    state: {
        bannerUrl: null,
        signee: null,
        shipAddress: null,
        shipLocation: null,
        shipDate: null,
        deliveryDate: null,
        shipCDS: null,
        shipDEA: null,
        shipLicense: null,
        shipStateDistributor: null,
        orderId: null,
        disclaimer: null,
        receivedBy: null,
        receivedByFirstName: null,
        receivedByMiddleName: null,
        receivedByLastName: null,
        receivedTitle: null,
        accountFirstName: null,
        accountMiddleName: null,
        accountLastName: null,
        accountCredentials: null,
        contentAcknowledgementItems: null
    },
    getters: {
        bannerUrl: state => state.bannerUrl,
        signee: state => state.signee,
        shipAddress: state => state.shipAddress,
        shipLocation: state => state.shipLocation,
        shipDate: state => state.shipDate,
        shipCDS: state => state.shipCDS,
        shipDEA: state => state.shipDEA,
        shipLicense: state => state.shipLicense,
        shipStateDistributor: state => state.shipStateDistributor,
        deliveryDate: state => state.deliveryDate,
        orderId: state => state.orderId,
        disclaimer: state => state.disclaimer,
        receivedBy: state => state.receivedBy,
        receivedByFirstName: state => state.receivedByFirstName,
        receivedByMiddleName: state => state.receivedByMiddleName,
        receivedByLastName: state => state.receivedByLastName,
        receivedTitle: state => state.receivedTitle,
        accountFirstName: state => state.accountFirstName,
        accountMiddleName: state => state.accountMiddleName,
        accountLastName: state => state.accountLastName,
        accountCredentials: state => state.accountCredentials,
        contentAcknowledgementItems: state => state.contentAcknowledgementItems,
    },
    mutations: {
        [MUTATION_NAME.SET_BANNER_URL]: (state, bannerUrl) => {
            state.bannerUrl = bannerUrl || null;
        },
        [MUTATION_NAME.SET_SIGNEE]: (state, signee) => {
            state.signee = signee || null;
        },
        [MUTATION_NAME.SET_SHIP_TO_ADDRESS]: (state, shipAddress) => {
            state.shipAddress = shipAddress || null;
        },
        [MUTATION_NAME.SET_SHIP_TO_LOCATION]: (state, shipLocation) => {
            state.shipLocation = shipLocation || null;
        },
        [MUTATION_NAME.SET_SHIP_TO_LICENSE]: (state, shipLicense) => {
            state.shipLicense = shipLicense || null;
        },
        [MUTATION_NAME.SET_SHIP_TO_DEA]: (state, shipDEA) => {
            state.shipDEA = shipDEA || null;
        },
        [MUTATION_NAME.SET_SHIP_CDS]: (state, shipCDS) => {
            state.shipCDS = shipCDS || null;
        },
        [MUTATION_NAME.SET_SHIP_STATE_DISTRIBUTOR]: (state, shipStateDistributor) => {
            state.shipStateDistributor = shipStateDistributor || null;
        },
        [MUTATION_NAME.SET_SHIP_DATE]: (state, shipDate) => {
            state.shipDate = shipDate || null;
        },
        [MUTATION_NAME.SET_DELIVERY_DATE]: (state, deliveryDate) => {
            state.deliveryDate = deliveryDate || null;
        },
        [MUTATION_NAME.SET_ORDER_ID]: (state, orderId) => {
            state.orderId = orderId || null;
        },
        [MUTATION_NAME.SET_ORDER_ID]: (state, orderId) => {
            state.orderId = orderId || null;
        },
        [MUTATION_NAME.SET_DISCLAIMER]: (state, disclaimer) => {
            state.disclaimer = disclaimer || null;
        },
        [MUTATION_NAME.SET_RECEIVED_BY]: (state, receivedBy) => {
            state.receivedBy = receivedBy || null;
        },
        [MUTATION_NAME.SET_RECEIVED_BY_FIRST_NAME]: (state, receivedByFirstName) => {
            state.receivedByFirstName = receivedByFirstName || null;
        },
        [MUTATION_NAME.SET_RECEIVED_BY_MIDDLE_NAME]: (state, receivedByMiddleName) => {
            state.receivedByMiddleName = receivedByMiddleName || null;
        },
        [MUTATION_NAME.SET_RECEIVED_BY_LAST_NAME]: (state, receivedByLastName) => {
            state.receivedByLastName = receivedByLastName || null;
        },
        [MUTATION_NAME.SET_RECEIVED_TITLE]: (state, receivedTitle) => {
            state.receivedTitle = receivedTitle || null;
        },
        [MUTATION_NAME.SET_ACCOUNT_FIRST_NAME]: (state, accountFirstName) => {
            state.accountFirstName = accountFirstName || null;
        },
        [MUTATION_NAME.SET_ACCOUNT_MIDDLE_NAME]: (state, accountMiddleName) => {
            state.accountMiddleName = accountMiddleName || null;
        },
        [MUTATION_NAME.SET_ACCOUNT_LAST_NAME]: (state, accountLastName) => {
            state.accountLastName = accountLastName || null;
        },
        [MUTATION_NAME.SET_ACCOUNT_CREDENTIALS]: (state, accountCredentials) => {
            state.accountCredentials = accountCredentials || null;
        },
        [MUTATION_NAME.SET_CONTENT_ACKNOWLEDGEMENT_ITEMS]: (state, contentAcknowledgementItems) => {
            state.contentAcknowledgementItems = contentAcknowledgementItems || null;
        }
    }
};

export default aocStore;
